var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayoutWrapper',{attrs:{"page":"programs/index","props":Object.assign({}, _vm.$props)}},[_c('DefaultProgramsView',{attrs:{"page-content":_vm.pageContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }